module.exports = __webpack_public_path__ + "static/manshour-cover-703453fa72af4859458c3d1b00c7fb19.jpg";